import DataList from "components/datatable/DataList";
import React from "react";
import useAxiosFunction from "hooks/useAxiosFunction";
import { useAuth } from "context/AuthProvider";
import { RuleRequired } from "utils/MyUtils";
import { hasPermission, parseBoolean, showEmpty } from "./SystemPageUtils";

const valueTypeOptions = [
  { id: "TEXT", label: "TEXT" },
  { id: "NUMBER", label: "NUMBER" },
  { id: "BOOLEAN", label: "BOOLEAN" },
  { id: "JSON", label: "JSON" },
  { id: "SECRET", label: "SECRET" },
];

export default function SettingsManagementPage() {
  const { user } = useAuth();
  const [, , , axiosFetch] = useAxiosFunction();
  const canManage = hasPermission(user, "system.setting.manage");

  const coltype = {
    id_setting: { type: "hidden", name: "id_setting" },
    setting_key: { label: "Setting Key", type: "text", name: "setting_key", colsize: 4, validation: RuleRequired, width: 220 },
    setting_value: { label: "Setting Value", type: "textarea", name: "setting_value", colsize: 12, validation: RuleRequired, renderFunc: (val) => showEmpty(val) },
    value_type: { label: "Value Type", type: "dropdown", name: "value_type", colsize: 3, options: valueTypeOptions, valueId: "id", labelId: "label", width: 120 },
    description: { label: "Description", type: "textarea", name: "description", colsize: 12, renderFunc: (val) => showEmpty(val) },
    is_public: { label: "Public", type: "checkbox", name: "is_public", renderFunc: (val) => (parseBoolean(val) ? "YA" : "TIDAK"), colsize: 2, width: 90 },
    action: { label: "Aksi", align: "center", width: 100 },
  };

  const saveSetting = async (form, defaultValue = {}) => {
    const id = form?.id_setting || defaultValue?.id_setting || "";
    const method = id ? "PUT" : "POST";
    const url = id ? `/system/settings/${id}` : "/system/settings";

    return axiosFetch({
      method,
      url,
      auth: true,
      data: {
        setting_key: form.setting_key,
        setting_value: form.setting_value || "",
        value_type: form.value_type || "",
        description: form.description || "",
        is_public: Boolean(form.is_public),
      },
    });
  };

  return (
    <DataList
      title="Daftar Setting"
      coltype={coltype}
      dlist={{
        url: "/system/admin/settings",
        columns: ["no", "setting_key", "value_type", "is_public", "description", "setting_value", "action"],
        filter: [{ dtype: "q", name: "q", colsize: 4 }],
        sort_by: ["setting_key", "value_type", "description"],
      }}
      addconfig={canManage ? {
        columns: ["setting_key", "value_type", "is_public", "setting_value", "description"],
        title: "Penambahan Setting",
        label_tool: "Tambah Setting",
        saveHandle: saveSetting,
      } : null}
      editconfig={canManage ? {
        columns: ["id_setting", "setting_key", "value_type", "is_public", "setting_value", "description"],
        title: "Perubahan Setting",
        url: "/system/settings",
        urlitem: "/system/settings",
        cellid: "id_setting",
        saveHandle: saveSetting,
      } : null}
      delconfig={canManage ? {
        url: "/system/settings",
        cellid: "id_setting",
        cellname: "setting_key",
      } : null}
    />
  );
}
